import React from 'react';

import { WidgetView, WidgetViewMode, WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { TitleEditName } from 'components/common/TitleEditName/TitleEditName';
import { TitleWithDrag } from 'components/common/TitleWithDrag/TitleWithDrag';
import classes from 'components/common/WidgetTitle/WidgetTitle.module.scss';

import { usePinboardWidgetWrapperContext } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/context/widgetWrapperContext';

interface Props {
    title: string;
    setTitle?: (value: string) => void;
    widgetViewMode?: WidgetViewMode;
    postfix?: React.ReactNode;
    showPostfixInEditMode?: boolean;
}

export const WidgetTitle = ({
    title,
    setTitle = () => {},
    widgetViewMode = WidgetView.page,
    postfix,
    showPostfixInEditMode = false,
}: Props) => {
    const { isFullscreen } = usePinboardWidgetWrapperContext();

    const isReportView = WidgetViewModeUtils.isReportView(widgetViewMode);
    const isReportAddOrEditWidget = WidgetViewModeUtils.isReportAddOrEditWidget(widgetViewMode);

    if (isReportView) {
        return <TitleWithDrag title={title} postfix={postfix} hideDrag={isFullscreen} />;
    }

    if (isReportAddOrEditWidget) {
        return (
            <>
                <TitleEditName value={title} onChange={setTitle} /> {showPostfixInEditMode ? postfix : ''}
            </>
        );
    }

    // Page/Pinboard view
    return (
        <div className={classes.title}>
            {title} {postfix ?? ''}
        </div>
    );
};
